module.exports = __webpack_public_path__ + "static/media/img_appstore.fa1d4746.png";